import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query superbill by unique id for email
 */
export default async function querySuperbillByUniqueIdForEmail(
  uniqueIdForEmail: string | number,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/superbill/unique_id_for_email/${uniqueIdForEmail}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to get superbill: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
